import { useMemo } from 'react';

import { Job, JobCompanyInfo } from '@kanda-libs/ks-frontend-services';

import { useJobContext } from 'pages/Job/context';

export interface QuoteHook {
  isLoading: boolean;
  job: Job | undefined;
  jobCompanyInfo: JobCompanyInfo | undefined;
  from: string;
  showChangesRequested: boolean;
  showChangesReceived: boolean;
}

export default function useQuote(): QuoteHook {
  const { isLoading, job, jobCompanyInfo, changesStatus } = useJobContext();

  const from = useMemo(() => {
    if (isLoading) return 'Your quote from your tradesperson';
    return `Your quote from ${
      jobCompanyInfo?.company_name ?? 'your tradesperson'
    }`;
  }, [isLoading, jobCompanyInfo]);

  const showChangesRequested = useMemo(
    () => changesStatus === 'REQUESTED',
    [changesStatus],
  );

  const showChangesReceived = useMemo(
    () => changesStatus === 'REVIEW',
    [changesStatus],
  );

  return {
    isLoading,
    job,
    jobCompanyInfo,
    from,
    showChangesRequested,
    showChangesReceived,
  };
}
